import React from 'react';
import moment from 'moment';
import classNames from 'classnames';

const ReceiptDetailsHeader = ({flightStart, flightEnd, pageIconClass, title, hideDates}) => {
    const startDate = moment(flightStart).format('M-D-YY');
    const endDate = moment(flightEnd).format('M-D-YY');
    const dates = hideDates ? null : (
        <div className="receipt-dates">
            <div className="date">
                <div className="date-title">Start Date</div>
                <div>{startDate}</div>
            </div>
            <div className="date">
                <div className="date-title">End Date</div>
                <div>{endDate}</div>
            </div>
        </div>
    );

    return (
        <div className="verify-receipt-details-header">
            <div className="receipt-title">
                <div className={classNames('title-icon', pageIconClass)} />
                <div className="title-text">{title}</div>
            </div>
            {dates}
        </div>
    );
};

export default ReceiptDetailsHeader;



// WEBPACK FOOTER //
// ./campaign_launch/verify_receipt/verify_receipt_details/receipt_details_header.js